import {
  CREATE_FARMER,
  UPDATE_FARMER_ITEM_QUANTITY,
  INVITE_SUPPLIER,
  GET_ALL_SUPPLIERS,
  GET_SINGLE_SUPPLIER,
  REFER_A_FARMER,
  FARMERS_LOADING
} from "../actions/types";

const initialState = {
  suppliers: [],
  loading: false,
  farmer: null,
  refer_a_farmer_email_sent: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FARMERS_LOADING:
      return {
        ...state,
        loading: true
      };
    case CREATE_FARMER:
      return {
        ...state,
        suppliers: [...state.suppliers, action.payload],
        loading: false
      };
    case UPDATE_FARMER_ITEM_QUANTITY:
      return {
        ...state,
        ...action.payload,
        loading: false
      };
    case REFER_A_FARMER:
      return {
        ...state,
        loading: false,
        refer_a_farmer_email_sent: true
      };
    case INVITE_SUPPLIER:
      return {
        ...state,
        suppliers: [...state.suppliers, action.supplier],
        loading: false
      };
    case GET_ALL_SUPPLIERS:
      return {
        ...state,
        suppliers: action.payload,
        loading: false
      };
    case GET_SINGLE_SUPPLIER:
      return {
        ...state,
        ...action.payload,
        loading: false
      };
    default:
      return state;
  }
}
